import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyAsyncExportServiceModel } from '../../../../shared/components';
import { OfflineExportsCrmExportTypesEnum } from '../../../../shared/enums';
import { SettingsResponse } from '../../../../shared/dto';
import { HubspotApiService } from '../../../../shared/services/api';

@Injectable()
export class CompanyHsAsyncExportService implements CompanyAsyncExportServiceModel {
    crmType: OfflineExportsCrmExportTypesEnum = OfflineExportsCrmExportTypesEnum.HUBSPOT;

    constructor(private readonly hubspotApiService: HubspotApiService) {
    }

    getSettingsDuplicateResolution(): Observable<string> {
        return this.hubspotApiService.getSettings()
            .pipe(map((response: SettingsResponse<any>) => response.general.hsDuplicateResolution));
    }
}
